import React, { type PropsWithChildren } from 'react';

import invariant from 'tiny-invariant';

import { useOptions } from '../../controllers/options-provider';
import { useNetworkMigrationSideNavUserData } from '../../controllers/user-state/persistence/use-network-side-nav-user-data';
import { StoreProviders } from '../../controllers/user-state/store-providers';

export function NetworkMigrationStore({ children }: PropsWithChildren): React.JSX.Element {
	const { networkStorageParams, app } = useOptions();

	invariant(
		networkStorageParams?.activationId &&
			networkStorageParams?.entityAri &&
			networkStorageParams?.siteId &&
			networkStorageParams?.ownerAri &&
			networkStorageParams?.queryRef,
		'Please provide networkStorageParams when using customization',
	);

	// This is user data for the menu and the sidebar
	const userStoreProps = useNetworkMigrationSideNavUserData({
		...networkStorageParams,
		firstPartyApp: app,
	});

	return <StoreProviders {...userStoreProps}>{children}</StoreProviders>;
}
